"use client";

import Image from "next/image";
import { Advertisement } from "./googlemapbanner";
import styles from "./MapAdvertisement.module.css";

interface MapAdvertisementProps {
  ad: Advertisement;
  onClick?: (slug: string) => void;
  onClose?: () => void;
}

export default function MapAdvertisement({
  ad,
  onClick,
  onClose,
}: MapAdvertisementProps) {
  const business =
    typeof ad.businessId === "string" ? undefined : ad.businessId;

  const imageUrl =
    ad.images?.[0]?.url || business?.logo?.url || "/images/logo-png.png";

  return (
    <div className={styles.mapAdWrapper}>
      <div className={styles.mapAdCard}>
        {/* Close button */}
        {onClose && (
          <button
            type="button"
            className={styles.mapAdClose}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            aria-label="Close advertisement"
          >
            ×
          </button>
        )}

        {/* Advertisement Image */}
        <div
          className={styles.mapAdImage}
          onClick={() => {
            if (business?.slug) {
              onClick?.(business.slug);
            }
          }}
        >
          <Image
            src={imageUrl}
            alt={business?.businessname || "Advertisement"}
            fill
            sizes="115px"
            className={styles.mapAdImg}
          />

          <div className={styles.mapAdBadge}>Sponsored</div>
        </div>

        {/* Advertisement Content */}
        <div className={styles.mapAdContent}>
          {/* Business name */}
          <div className={styles.mapAdTitle}>
            {business?.businessname || "Featured Business"}
          </div>

          {/* Description */}
          {business?.businessdescription && (
            <div className={styles.mapAdDescription}>
              {business.businessdescription}
            </div>
          )}

          {/* View Business */}
          <button
            type="button"
            className={styles.mapAdButton}
            onClick={() => {
              if (business?.slug) {
                onClick?.(business.slug);
              }
            }}
            disabled={!business?.slug}
          >
            View Business
            <span>→</span>
          </button>
        </div>
      </div>
    </div>
  );
}
